import React, { useEffect, useRef } from "react";

// ✅ Testimonial data in JSON format
const testimonialsData = [
  {
    id: 1,
    // name: "Aarav Sharma",
    // role: "Startup Founder",
    videoUrl: "https://res.cloudinary.com/dg0eeyvud/video/upload/v1770463927/UG_SC_01_-_Work_and_Study_Fulltime_s3pb90.mp4",
    // quote: "This product completely changed how we onboard users."
  },
  {
    id: 2,
    // name: "Emily Johnson",
    // role: "Marketing Lead",
    videoUrl: "https://res.cloudinary.com/dg0eeyvud/video/upload/v1770464315/AD_Ridwan_01_Business_Finance_xgr7f7.mp4",
    // quote: "Engagement went through the roof after using this."
  },
  {
    id: 3,
    // name: "Rahul Mehta",
    // role: "Product Manager",
    videoUrl: "https://res.cloudinary.com/dg0eeyvud/video/upload/v1770464015/UG_SC_3_-_top_3_mistakes_in_application_process_hp735a.mp4",
    // quote: "Super intuitive and insanely effective."
  },
  {
    id: 4,
    // name: "Rahul Mehta",
    // role: "Product Manager",
    videoUrl: "https://res.cloudinary.com/dg0eeyvud/video/upload/v1770464328/AD_Ridwan_02_-_General_gem0wq.mp4",
    // quote: "Super intuitive and insanely effective."
  },
  {
    id: 5,
    // name: "Rahul Mehta",
    // role: "Product Manager",
    videoUrl: "https://res.cloudinary.com/dg0eeyvud/video/upload/v1770463202/UG_SC_02_-_Professional_in_home_country_Music_iug9xq.mp4",
    // quote: "Super intuitive and insanely effective."
  }
];

const VideoTestimonials = () => {
  const videoRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.7 // 70% visible = play
      }
    );

    videoRefs.current.forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="container" style={styles.wrapper}>
      {testimonialsData.map((item, index) => (
        <div key={item.id} style={styles.card}>

            <video
                ref={(el) => (videoRefs.current[index] = el)}
                src={item.videoUrl}
                style={styles.video}
                muted
                loop
                playsInline
                controls
            />
          {/* <video
            ref={(el) => (videoRefs.current[index] = el)}
            src={item.videoUrl}
            style={styles.video}
            muted
            loop
            playsInline
            preload="metadata"
          /> */}
        </div>
      ))}
    </div>
  );
};

export default VideoTestimonials;

// 🎨 Basic styling (Reels-style vertical cards)
const styles = {
  wrapper: {
    display: "flex",
    gap: "16px",
    overflowX: "auto",
    padding: "16px",
    scrollSnapType: "x mandatory"
  },
  card: {
    minWidth: "280px",
    height: "500px",
    borderRadius: "16px",
    overflow: "hidden",
    backgroundColor: "#000",
    scrollSnapAlign: "start",
    flexShrink: 0
  },
  video: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    cursor: "pointer"
  }
};